import { styled } from '@material-ui/core';

export const BaseStyledTable = styled('table')({
  borderCollapse: 'separate',
  borderSpacing: 0,
  tableLayout: 'fixed',
  width: '100%',
  minWidth: '600px',
  margin: 'var(--encore-spacing-base) 0',
  border: '1px solid var(--essential-subdued)',
  borderRadius: 'var(--encore-corner-radius-base)',
  backgroundColor: 'var(--background-base)',
  lineHeight: 1.4,

  '& td': {
    minWidth: '100px',
    borderBottom: '1px solid var(--decorative-subdued)',
    padding: 'var(--encore-spacing-tighter-4) var(--encore-spacing-tighter-2)',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    position: 'relative',
    fontFamily: 'var(--encore-body-font-stack)',
    color: 'var(--text-base)',
    fontSize: 'var(--encore-text-size-smaller)',
    lineHeight: 1.4,
  },

  '& th': {
    minWidth: '100px',
    borderBottom: '1px solid var(--decorative-subdued)',
    padding: 'var(--encore-spacing-tighter-4) var(--encore-spacing-tighter-2)',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    position: 'relative',
    fontFamily: 'var(--encore-body-font-stack)',
    fontWeight: 600,
    fontSize: 'var(--encore-text-size-smaller-3)',
    lineHeight: 1.4,
    textAlign: 'left',
    backgroundColor: 'var(--background-elevated-base)',
    color: 'var(--text-subdued)',
    letterSpacing: '0.025em',
  },

  '& td > p': {
    margin: 0,
  },

  '& tr:last-child td': {
    borderBottom: 'none',
  },

  '& tr:last-child th': {
    borderBottom: '1px solid var(--decorative-subdued)',
  },
});
